export const shouldDisplayTreatment = item => {
  if (!item) {
    return false;
  }

  const { title, extraTitle, details, highlight } = item;

  return Boolean(title || extraTitle || details || highlight);
};
